<div class="save-confirm-pop-up"
     [ngStyle]="{'top': positionTop + 'px',
                 'right': positionRight + 'px',
                 'bottom': positionBottom + 'px',
                 'left': positionLeft + 'px'}"

>
  <p>{{ confirmMessage | anessaTranslation: trigger }}</p>
  <div class="compact-button-group">
    <button id="confirmation-pop-up-confirm"
            class="btn-compact btn-green"
            mat-button
            type="button"
            (click)="confirmClick()"
    >{{ confirmText | anessaTranslation: trigger }}</button>
    <button id="confirmation-pop-up-reject"
            class="btn-compact btn-red"
            mat-button
            type="button"
            (click)="rejectClick()"
    >{{ rejectText | anessaTranslation: trigger }}</button>
  </div>
</div>
